import { cookies } from 'lib/enums';
import { LIVE_AGENT_EXCLUSION_LIST } from 'config/third_party';
import $ from 'jquery';
import 'bootstrap';
import Backbone from 'backbone';
import PurchaseView from 'views/store/pages/products/purchase';
import ConfigView from 'views/store/pages/products/config';
import HeadingView from 'views/store/pages/products/heading';
import UniqueIdView from 'views/store/pages/products/uniqueid';
import MediaGalleryView from 'views/store/pages/products/mediagallery';
import GalleryView from 'views/store/pages/products/gallery';
import VideosView from 'views/store/pages/products/videos';
import ReviewsView from 'views/store/pages/products/reviews';
import PricedOptionView from 'views/store/pages/products/pricedoption';
import ProductHelper from 'views/store/common/helpers/product_helper';
import ProductModel from 'models/store/client/product/product';
import PricedOptionModel from 'models/store/client/product/pricedoption';
import SocialBarView from 'views/store/common/social/social_bar';
import VendorStockView from 'views/store/pages/products/vendor_stock.page';
import { AddToProjectView, AddToTypes } from 'src/app/views/store/common/projects/add_to_project';
import GoodBetterBestView from 'views/store/common/_good_better_best';
import _goodBetterBestDetailsDust from 'store/global/pages/products/_good_better_best_details.dust';
import PaintCalculatorView from 'views/store/pages/paint/calculator';
import RestrictionsView from 'views/store/pages/products/restrictions';
import dustjs from 'dustjs';
import _viewMoreButtonDust from 'store/mobile/pages/products/_view_more_button.dust';
import RelatedCategoriesView from 'views/store/pages/products/related_categories';
import LiveAgentInvitationView from 'views/store/common/live_agent_invitation';
import CategoryExpertView from 'views/store/pages/products/category_expert';
import RebatesView from 'views/store/pages/products/rebates';
import jsCookie from 'js-cookie';
import url from 'app/url';
import utils from 'app/views/store/common/utility/index';
import { clientUtils } from 'app/client_utils';
import 'vendor/matchmedia.addListener';
import 'jquery.scrollto';
import gtmHelper from 'lib/helpers/gtm_helper';

window.BCOM.views = window.BCOM.views || {};
window.BCOM.models = window.BCOM.models || {};
window.BCOM.collections = window.BCOM.collections || {};

export default Backbone.View.extend({
	el: '#product',
	model: new ProductModel(window.dataLayer),
	events: {
		'click .js-view-pdf': 'viewPDF',
		'click .js-rating-link': 'trackReviewLink',
		'click #product-tabs a': 'openTab',
		'click .js-expandable-details': '_trackProductExpand',
		'click .js-reviews-expandable': '_initReviews',
		'click .js-q-and-a-expandable': '_initQuestions',
		'click .js-matching-products-expandable': '_initMatchingProducts',
		'click .js-parts-expandable': '_initParts',
		'shown.bs.tab a[href="#specifications"]': '_initSpecifications',
		'shown.bs.collapse #specifications': '_initSpecifications',
		'shown.bs.tab a[href="#videos"]': '_initVideos',
		'shown.bs.collapse #videos': '_initVideos',
		'shown.bs.modal .js-video-modal': '_initVideos',
		'shown.bs.tab a[href="#q-and-a"]': '_initQuestions',
		'shown.bs.collapse #q-and-a': '_initQuestions',
		'shown.bs.tab a[href="#reviews"]': '_initReviews',
		'shown.bs.collapse #reviews': '_initReviews',
		'shown.bs.tab a[href="#matching-products"]': '_initMatchingProducts',
		'shown.bs.collapse #matching-products': '_initMatchingProducts',
		'shown.bs.tab a[href="#parts"]': '_initParts',
		'shown.bs.collapse #parts': '_initParts',
		'shown.bs.collapse .panel-collapse': '_mobileTabShown',
		'hidden.bs.modal .js-modal-product-options': '_notifyClosedModal',
		'show.bs.collapse .panel-collapse.has-icon': 'toggleProductAccordian',
		'hidden.bs.collapse .panel-collapse.has-icon': 'toggleProductAccordian',
		'affix.bs.affix #product-images-container': 'onMediaGalleryAffix',
		'click dl.divide-items a': 'trackHoverClick',
		'click .js-print': 'printWindow',
		'click .js-view-more': '_toggleFullTab',
		'click .js-view-more-specs': '_toggleSpecs',
		'click .js-full-title-toggle': '_toggleFullSubHeading',
		'click .js-finishes-menu .js-toggle-menu': '_finishMenuClosed',
		'click .js-credit-card-landing': '_creditCardLanding',
		'click .js-open-manufacturer-warranty': '_openManufacturerWarranty',
		'click .js-prop-65-popover': '_toggleProp65Popover',
		'click .js-prop-65-popover-icon': '_toggleProp65Popover',
		'click .js-tech-spec': '_techSpecPopoverPDP',
		'click .js-book-showroom-appointment': 'toggleShowroomModal'
	},
	/**
	 * Since some browsers behave differently when opening a PDF file.
	 * We explicitly want to try to open it in a new window.
	 * Based on Content-Disposition header it will open in new window/tab/download the PDF.
	 */
	viewPDF: function(e) {
		const $target = $(e.currentTarget);
		const url = $target.data('href');
		if (url) {
			window.open(url);
		}
	},
	initialize: function(opts = {}) {
		this.options = { ...opts, parentView: this };
		const $productDetailsContainer = $('.js-product-details-container');
		this.$productImagesContainer = $('#product-images-container');
		this.shouldRenderSpecs = window.BCOM.device.isMobile;

		this.childViews.title = new HeadingView({
			model: this.model
		});
		this.childViews.uniqueid = new UniqueIdView({
			model: this.model
		});

		this.childViews.purchase = new PurchaseView(this.options);
		this.childViews.config = new ConfigView(this.options);

		if (this._isPDPOnDesktop()) {
			this.childViews.gallery = new GalleryView({
				model: this.model
			});
		} else {
			this.childViews.mediaGallery = new MediaGalleryView({
				model: this.model
			});
		}

		if (!window.dataLayer.siteId || !LIVE_AGENT_EXCLUSION_LIST.SITE_ID_LIST.includes(window.dataLayer.siteId)) {
			this.childViews.liveAgentInvitation = new LiveAgentInvitationView({
				sourcePage: 'product'
			});
		}
		this.childViews.social = new SocialBarView();
		this.childViews.vendorStock = new VendorStockView();
		this._initExpertView();
		const addToCartView = this.childViews.purchase.childViews.addToCart;
		this.childViews.AddToProjectView = new AddToProjectView({
			getDecoratedSaveData: () => ProductHelper.getDefaultCartItemModelConfig(this.model),
			canShowSelectorHook: addToCartView._canAddToCart.bind(addToCartView, $('.js-add-to-cart')),
			hasPreSaveBlocker: () => {
				return (
					!addToCartView.shouldSaveBeforeRedirect.call(addToCartView) &&
					addToCartView.shouldRedirectToConfigPage.call(addToCartView)
				);
			},
			preSaveBlocker: addToCartView.handleRedirect.bind(addToCartView),
			postSuccessHook: addToCartView.handleRedirect.bind(addToCartView),
			quickAddInfo: {
				type: AddToTypes.PRODUCT,
				displayName: `${window.dataLayer.manufacturer} ${window.dataLayer.productId}`
			}
		});
		if (window.dataLayer.isLocalUser) {
			this.childViews.goodBetterBest = new GoodBetterBestView({
				el: '.js-good-better-best',
				template: _goodBetterBestDetailsDust,
				data: window.dataLayer.goodBetterBest
			});
		}
		if (this.model.offersInstallation()) {
			this.childViews.installation = new PricedOptionView({
				model: new PricedOptionModel(this.model.getInstallationData())
			});
		}
		if (this.model.attributes.product.excessiveLead) {
			$('#excessiveLeadModal').modal('show');
		}
		if (this.model.get('hasPaint')) {
			this.childViews.paintCalculator = new PaintCalculatorView();
		}

		this.childViews.relatedCategories = new RelatedCategoriesView();

		if (window.dataLayer.enableEcoRebates) {
			this.childViews.rebates = new RebatesView();
		}

		this.listenTo(Backbone, 'product:configurePricedOptions', this.configureProduct, this);

		this.listenTo(Backbone, 'tabContent:scrollTo', this.scrollToTabContent);

		this.listenTo(Backbone, 'zipCode:changed', this.updateShowroomZipCode);

		window.matchMedia('(orientation:landscape)').addListener((event) => {
			this.handleOrientationChange(event.matches);
		});

		$(window).on('orientationchange', (event) => {
			this.handleOrientationChange(event.originalEvent.orientation === 'landscape');
		});

		if (this.$('#videos').is(':visible')) {
			this._initVideos();
		}
		if (this.$('#q-and-a').is(':visible')) {
			this._initQuestions();
		}
		if (this.$('#parts').is(':visible')) {
			this._initParts();
		}

		this._initRestrictionsView(this.options);

		if (window.BCOM.device.isDesktop) {
			if (this.$('#matching-products').is(':visible')) {
				this._initMatchingProducts();
			}
		} else {
			this._initMatchingProducts.call(this);
		}

		this._initReviews();
		if (window.BCOM.device.isMobile) {
			this._addViewMoreButton('overview');

			// check to see if over 400px of scroll has occured to load tabs and stop listener
			const handler = (event) => {
				var hasScrolled = document.body.getBoundingClientRect().top + 400 < 0;
				if (hasScrolled) {
					this._loadTabs();
					event.currentTarget.removeEventListener(event.type, handler);
				}
			};

			window.addEventListener('scroll', handler);
		}

		this.listenTo(Backbone, 'quantity:changed', this.updateRecommendedOptionQuantities, this);
		if (!this.model.get('hasNonServiceOptions') && !window.BCOM.device.isDesktop) {
			// We may have to show the 'configure' state of the page
			this.listenTo(Backbone, 'availability:stateChanged', this._onAvailabilityChanged, this);
		}

		this.tabHashes = [
			'#reviews',
			'#q-and-a',
			'#specifications',
			'#matching-products',
			'#videos',
			'#parts',
			'#compatability-checker',
			'#savings-calclator'
		];
		if (window.location.hash && window.location.hash.length) {
			this._scrollToTab(window.location.hash);
			if (!window.BCOM.device.isMobile) {
				this._initReviews();
			}
		}
		const urlParams = url.getParameters();
		if (urlParams && urlParams.reviews && urlParams.reviews === 'true') {
			this._scrollToTab('#reviews');
		}

		this.saveLastProductUrl(window.dataLayer.selectedFinish.url);
		this._initInternalTools();
		if (window.dataLayer.hasOmcRebates && window.dataLayer.enableOmcRebates) {
			import('views/store/pages/products/omc_rebates')
				.then((OmcRebatesView) => {
					this.childViews.omcRebates = new OmcRebatesView();
				})
				.catch(window.clientErrorHandler);
		}
		// initialize tooltips if any;
		$('[data-toggle="tooltip"]').tooltip();

		jsCookie.set(cookies.LAST_PRODUCT, window.location.href, {
			path: '/'
		});

		if (!this.shouldRenderSpecs) {
			this.$el.find('.js-view-more-specs').trigger('click', true);
			this.$el
				.find('#product-specs')
				.find('[data-toggle="popover"]')
				.popover({
					placement: 'top',
					container: 'body',
					html: true
				});
			if (!window.location.hash) {
				this.$el
					.find('#product-tabs li:first')
					.find('a')
					.tab('show');
			}
		}
		const isDiscontinuedProduct = window.dataLayer.pageName.includes('product-discontinued');
		if (!isDiscontinuedProduct && $productDetailsContainer.length && this.$productImagesContainer.length) {
			const topOffset = $productDetailsContainer.offset().top - 16;
			const bottomOffset = function() {
				return document.body.scrollHeight - $productDetailsContainer.offset().top - $productDetailsContainer.outerHeight();
			};
			this.initializeAffix(this.$productImagesContainer, topOffset, bottomOffset);
		}

		// trigger a finish change event to fix the page since we didn't do it in the dust templates
		Backbone.trigger('finish:clicked', window.dataLayer.selectedFinish);
		clientUtils._initPopovers('.js-tech-spec');
		this.initProp65Popover();
		this.listenTo(Backbone, 'body:click', this._handleBodyClickPDP);
		if (window.dataLayer.isPurchaseByAppointmentOnly) {
			const ShowroomLinksView = require('views/store/pages/content/showroom-links');
			this.childViews.showroomLinks = new ShowroomLinksView({
				brand: this.model.get('manufacturer')
			});
		}

		this._fireGA360PageloadTracking();
	},
	_isPDPOnDesktop() {
		return !window.dataLayer.isPla && window.BCOM.device.isDesktop;
	},
	_techSpecPopoverPDP: function(e) {
		const currentTarget = e.currentTarget;
		const techSpecClass = '.js-tech-spec';
		clientUtils._handleMultiplePopoversClick(techSpecClass, currentTarget);
		// mainly prevent body click event from firing.
		e.stopPropagation();
	},
	_handleBodyClickPDP: function(e) {
		const targetElement = $(e.target);
		// any new popover triggering classes on the page to be added to this string to handle its body click hiding action
		const allPopoverClassesOnPage = '.js-tech-spec, .js-prop-65-popover';
		clientUtils._handleBodyClick(targetElement, allPopoverClassesOnPage);
	},
	initializeAffix: function($productImagesContainer, top, bottom) {
		$productImagesContainer.affix({
			offset: {
				top,
				bottom
			}
		});
		// For users with fast scroll the above affix does not get reset when scrolled too fast.
		// This recalculate the affix position.
		$(window).on(
			'scroll',
			utils.debounce(() => {
				$productImagesContainer.affix('checkPosition');
			}, 300)
		);
	},
	initProp65Popover: () => {
		// add elements to the whitelist so they are not removed by sanitizer
		const whiteList = $.fn.popover.Constructor.DEFAULTS.whiteList;
		whiteList.table = [];
		whiteList.tbody = [];
		whiteList.tr = [];
		whiteList.th = [];
		whiteList.td = [];
		const $popoverTarget = $('.js-prop-65-popover');
		$popoverTarget.popover({
			title: 'Proposition 65 Applicable (CA Only)',
			placement: 'top',
			trigger: 'click',
			html: true,
			sanitize: true
		});
	},
	_toggleProp65Popover: function() {
		$('.js-prop-65-popover').popover('toggle');
		// mainly prevent body click event from firing.
		return false;
	},
	onMediaGalleryAffix: function(e) {
		const $target = $(e.currentTarget);
		$target.css('width', $('.product-images-module').outerWidth() - 30);
	},
	_openManufacturerWarranty: function() {
		const warrantyText = this.model.get('warrantyText');
		const manufacturer = this.model.get('manufacturer');
		if (warrantyText && manufacturer) {
			const w = window.open('', manufacturer, 'width=600,height=600');
			const html = `
				<div style="padding: 16px; font-size: 16px; line-height: 1.6rem;">
					<h1>${manufacturer} Warranty</h1>
					<div>${warrantyText}</div>
				</div>
			`;
			w.document.write(html);
			w.document.title = `${manufacturer} Warranty`;
		}
	},
	/**
	 * Togggle the view for specs in combined view with overview.
	 */
	_toggleSpecs: function(e, onInit) {
		const $elem = $(e.currentTarget),
			$btn = $elem.find('button'),
			isViewMore = $btn.text().toLowerCase() === 'view more';
		$btn.text(isViewMore ? 'View Less' : 'View More');
		const $specsContainer = this.$el.find('#product-specs');
		const specsContainerHeight = $specsContainer.outerHeight();
		const $viewMoreSpecsElem = $specsContainer.find('.js-view-more-specs');
		if (isViewMore) {
			$specsContainer.css({
				'max-height': '4000px',
				'min-height': '300px',
				overflow: 'auto'
			});
			$viewMoreSpecsElem.removeClass('shadow');
		} else {
			const $overviewDetailContainer = this.$el.find('.js-overview-details');
			const overviewContainerHeight = $overviewDetailContainer.outerHeight();
			if (specsContainerHeight > overviewContainerHeight) {
				const totalHeight =
					($('#overview-videos').outerHeight() || 0) +
					($('related-categories').outerHeight() || 0) +
					($('#manufacturer-resources').outerHeight() || 0);
				let maxHeight = overviewContainerHeight - totalHeight;
				$specsContainer.css({
					'max-height': `${maxHeight}px`,
					overflow: 'hidden',
					'min-height': '300px'
				});
				$viewMoreSpecsElem.addClass('shadow');
				if (!onInit) {
					$('html, body').animate(
						{
							scrollTop: $viewMoreSpecsElem.position().top + 300
						},
						500
					);
				}
			} else {
				// No need for view more
				$viewMoreSpecsElem.addClass('dn');
			}
		}
	},
	_scrollToTab: function(hash) {
		if (this.tabHashes.indexOf(hash) > -1) {
			if (!window.BCOM.device.isMobile && hash === '#reviews') {
				this._initReviews();
			}
			this.scrollToTabContent(hash.substr(1));
		}
	},
	refreshView: function(newModel) {
		if (window.BCOM.views.questions) {
			window.BCOM.views.questions.remove();
			window.BCOM.views.questions = null;
		}
		this.childViews = {};
		this.model = new ProductModel(newModel);
		this.initialize();
		$('#product-tabs li a[href="#q-and-a"]').on('shown.bs.tab', this._initQuestions.bind(this));
		this.delegateEvents();
		this.initChildViews();
		this.$productImagesContainer.on('affix.bs.affix', this.onMediaGalleryAffix.bind(this));
	},
	initChildViews: function() {
		this._initReviews();
		this._initVideos();
		this._initQuestions();
		this._initParts();
		this._initSpecifications();
		this._initInternalTools();
		this._initMatchingProducts();
		this._initRestrictionsView(this.options);
		this._initExpertView();
	},

	trackHoverClick: function(e) {
		e.preventDefault();
		Backbone.trigger('omniture:clicktracking', `${this._getDevice()}hoverTechSpecs_${e.currentTarget.title}`);
	},

	// init tabs
	openTab: function(e) {
		e.preventDefault();
		$(e.currentTarget).tab('show');
		this.selectedTabHash = e.currentTarget.hash;
		window.location.hash = this.selectedTabHash;
		this._trackProductTab();
	},

	updateRecommendedOptionQuantities: function(quantityInfo) {
		var quantity;

		if (this.model.hasPricingByUOM()) {
			quantity = this.model.getQuantityForSquareFootage(quantityInfo.quantity);
		} else {
			quantity = quantityInfo.quantity;
		}

		if (quantityInfo.id === 'main-product-quantity') {
			this.model.recommendedOptions.each(function(option) {
				option.set('quantity', quantity);
			});
			this.childViews.recommendedOptions.forEach((optionView) => {
				optionView.matchOptionQuantityToProductQuantity();
			});
		}
	},

	handleOrientationChange: function(isLandscape) {
		if (isLandscape && this.selectedTabHash === '#product-specs-portrait') {
			this.$('#product-tabs li:first a').trigger('click');
		}
	},

	scrollToTabContent: function(tabName) {
		let tabSelector = `#${tabName}`,
			$tab = $(tabSelector),
			$tabLink = $(`a[href="${tabSelector}"]`);
		const $expand = $(`.js-${tabName}-expandable .js-expand`);
		if ($tab && $tab.length) {
			if (
				tabName &&
				!$tab
					.closest('.panel')
					.find('.panel-collapse')
					.hasClass('in')
			) {
				$tabLink.trigger('click');
			}

			$('body').scrollTo($tab, 800, {
				axis: 'y'
			});
		}
		if ($expand && $expand.length) {
			$expand.click();
		}
	},
	_trackProductExpand: function(event) {
		const id = $(event.target)
			.closest('.js-expandable-details')
			.attr('id');
		Backbone.trigger('omniture:clicktracking', `${this._getDevice()}expand_${id}`);
	},
	_trackProductTab: function() {
		Backbone.trigger('omniture:clicktracking', `${this._getDevice()}tab_${this.selectedTabHash.replace('#', '')}`);
	},
	// init tracking for mobile
	_mobileTabShown: function(e) {
		var id = e.target.id;
		Backbone.trigger('omniture:clicktracking', `${this._getDevice()}tab_${id}`);
	},
	// tracking for link to reviews
	_trackReviewLink: function() {
		Backbone.trigger('omniture:clicktracking', `${this._getDevice()}tab_rating-link`);
	},
	_initRestrictionsView: function(options) {
		const restrictions = window.dataLayer.restrictions;
		this.childViews.restrictions = new RestrictionsView({
			el: '.js-product-restrictions-container',
			containerEl: options.containerEl,
			collection: restrictions || [],
			finishes: this.model.get('finishes'),
			selectedFinish: this.model.get('selectedFinish'),
			productCompositeId: this.model.get('productCompositeId')
		});
	},
	_initSpecifications: function() {
		if (!this.childViews.specifications && this.shouldRenderSpecs) {
			import('views/store/pages/products/group_specifications')
				.then((SpecificationsView) => {
					this.childViews.specifications = new SpecificationsView({
						productCompositeId: this.model.get('productCompositeId')
					});
				})
				.catch(window.clientErrorHandler);
		}
	},

	_onShowReview() {
		if (window.dataLayer.isPla) {
			const fullProdPageUrl = $('.js-full-product-page').data('location');
			window.location.assign(
				`${window.BCOM.util.updateURLParameters(fullProdPageUrl, 'uid', window.dataLayer.selectedFinishId)}#reviews`
			);
			return;
		}
		this._scrollToTab('#reviews');
	},

	_initReviews: function(callback = null) {
		if (!this.childViews.reviews) {
			this.childViews.reviews = new ReviewsView({
				el: 'body',
				url: window.dataLayer.bvUrl,
				zone: window.dataLayer.bvDeploymentZone,
				productId: window.dataLayer.product.familyId,
				callback,
				onShowReview: this._onShowReview.bind(this, Backbone)
			});
		}
		this._addViewMoreButton('reviews', '.bv-cleanslate');
	},

	_initQuestions: function() {
		const isEdgeStar = window.dataLayer.siteId === 95;
		const isAlreadyLoaded = window.BCOM.views.questions;

		if (!isEdgeStar && !isAlreadyLoaded) {
			this._addViewMoreButton('q-and-a', '.q-and-a-list');
		}
	},

	_getDevice: function() {
		const tabletOrDesktop = window.BCOM.device.isTablet ? 'tablet' : 'desktop';
		return window.BCOM.device.isMobile ? 'mobile' : tabletOrDesktop;
	},

	_initVideos: function() {
		if (!this.childViews.video) {
			this.childViews.video = new VideosView({
				parentView: this,
				el: '#videos'
			});
			if (window.BCOM.device.isMobile) {
				this._addViewMoreButton('videos', '.video');
			}
		}
	},

	_notifyClosedModal: function() {
		Backbone.trigger('modal:close');
	},

	printWindow: function() {
		window.print();
	},

	_initMatchingProducts: function() {
		try {
			if (!this.childViews.matchingProducts) {
				import('views/store/pages/products/matching_products').then((MatchingProductsTabView) => {
					this.childViews.matchingProducts = new MatchingProductsTabView({
						parentView: this
					});
					this._addViewMoreButton('matching-products', '.product-grid');
				});
			}
		} catch (e) {
			window.clientErrorHandler(e);
		}
	},

	_initParts: function() {
		if (!this.childViews.parts) {
			import('views/store/pages/products/parts_tab')
				.then((PartsView) => {
					this.childViews.parts = new PartsView();
					this._addViewMoreButton('parts', '.parts-grid li');
				})
				.catch((e) => {
					window.clientErrorHandler(e);
				});
		}
	},
	_toggleFullTab: function(e) {
		var $div = $(e.currentTarget),
			$btn = $div.find('button'),
			tab = $btn.data('tab'),
			isViewMore = $btn.text().toLowerCase() === 'view more';

		$btn.text(isViewMore ? 'View Less' : 'View More');

		if (!isViewMore) {
			setTimeout(function() {
				$('body').animate(
					{
						scrollTop: $(`#${tab}`).offset().top + 800
					},
					1000
				);
			}, 200);
		}
		$div.siblings('.js-content').toggleClass('full');
		Backbone.trigger('omniture:clicktracking', `${tab} tab:view more`);
	},
	_toggleFullSubHeading: function(e) {
		e.preventDefault();
		this.$('.js-full-title-toggle').toggleClass('hidden');
		this.$('.js-full-title').toggleClass('show-partial');
	},
	_finishMenuClosed: function() {
		Backbone.trigger('omniture:clicktracking', 'finish menu:closed');
	},
	_loadTabs: function() {
		this._initSpecifications();
		this._addViewMoreButton('specifications', 'table');
	},
	_addViewMoreButton: function(tab, elementLoaded) {
		if (window.BCOM.device.isMobile) {
			var $content = $(`#${tab} .js-content`),
				partialHeight = parseInt($content.css('max-height'), 10);

			window.BCOM.util.elementLoaded(
				{
					selector: `#${tab}${elementLoaded ? ` ${elementLoaded}` : ''}`
				},
				function() {
					if ($content.length && $content[0].scrollHeight > partialHeight && !$content.siblings('.js-view-more').length) {
						dustjs.render(
							_viewMoreButtonDust,
							{
								tab: tab
							},
							function(err, markup) {
								$content.after(markup);
							}
						);
					}
				}
			);
		}
	},
	_initInternalTools: function() {
		if (window.dataLayer.isLocalUser) {
			import('views/store/pages/products/internal_tools')
				.then((InternalToolsView) => {
					this.childViews.internalTools = new InternalToolsView();
				})
				.catch(window.clientErrorHandler);
		}
	},
	saveLastProductUrl: function(lastProductUrl) {
		jsCookie.set(cookies.LAST_PRODUCT, lastProductUrl, {
			expires: 45,
			path: '/'
		});
	},
	_onAvailabilityChanged: function(params) {
		if (params.newState !== 'AVAILABLE') {
			return;
		}

		var uniqueId = parseInt(params.uniqueId, 10);
		var selectedFinish = this.model.finishes.getSelectedFinish();
		if (uniqueId !== selectedFinish.get('uniqueId')) {
			return;
		}

		var oldHasPricedOptions = this.model.hasPricedOptionsExcludingInstall();
		var newHasPricedOptions = !params.services || params.services.length > 0;
		if (oldHasPricedOptions !== newHasPricedOptions) {
			var buttons = this.$('.js-add-to-cart');
			if (newHasPricedOptions && this.originalAddText) {
				buttons.html(this.originalAddText);
			} else {
				this.originalAddText = buttons.html();
				buttons.html(this.originalAddText.replace(buttons.text(), 'Add To Cart'));
			}
		}

		this.model.set('hasPricedOptionsExcludingInstall', newHasPricedOptions);
	},
	_creditCardLanding: function(event) {
		event.preventDefault();
		const trackingData = {
			evars: {
				eVar2: `creditcard|pg_${window.dataLayer.page}|t_${window.dataLayer.product.type}|a_${window.dataLayer.product.application}|m_${window.dataLayer.manufacturer}`
			}
		};

		gtmHelper.fireEvent({
			event: 'internal-campagin-click',
			linkName: trackingData.evars.evar2
		});

		Backbone.trigger('track:link', trackingData);
		// set opener to null to prevent vulnerability
		window.opener = null;
		window.open(
			$(event.currentTarget)
				.closest('a')
				.attr('href')
		);
	},
	toggleProductAccordian: function(event) {
		const $parentNode = $(event.currentTarget.parentNode);
		$parentNode.find('.js-expand-icon').toggleClass('ico-hide');
		$parentNode.find('.js-collapse-icon').toggleClass('ico-hide');
	},
	toggleShowroomModal: function() {
		if (!$('.js-book-showroom-appointment').length) {
			return;
		}
		const trackingData = {
			events: ['event176'],
			evars: {
				eVar95: 'PDP button'
			}
		};

		gtmHelper.fireEvent({
			event: 'generic-click-tracking',
			linkName: 'PDP button'
		});

		Backbone.trigger('track:link', trackingData);

		let zipCode;

		if (this.userUpdatedZipCode) {
			zipCode = this.userUpdatedZipCode;
		} else if (window.dataLayer.customerLocation) {
			zipCode = window.dataLayer.customerLocation.zipCode;
		}

		this.updateShowroomZipCode(zipCode);

		$('#js-showroom-modal').modal('show');
	},
	updateShowroomZipCode: function(zipCode) {
		this.userUpdatedZipCode = zipCode;
		$('#showroom-iframe').attr('src', 'https://customer.jrni.com/?client=ferguson&product=build#/location');
	},
	_initExpertView() {
		this.childViews.expertView = new CategoryExpertView();
	},
	_fireGA360PageloadTracking() {
		// GA360 product detail view event
		const selectedFinish = this.model.get('selectedFinish');

		gtmHelper.fireEvent({
			event: 'product-detail-view',
			ecommerce: {
				detail: {
					products: [
						gtmHelper.mapProductData({
							uniqueId: selectedFinish.uniqueId,
							baseCategory: this.model.get('baseCategory'),
							finishName: selectedFinish.name,
							manufacturer: this.model.get('manufacturer'),
							price: selectedFinish.priceValue,
							businessCategory: this.model.get('product').businessCategory,
							collection: this.model.get('collection'),
							type: this.model.get('product').type,
							application: this.model.get('product').application,
							stockCount: selectedFinish.stockCount,
							image: selectedFinish.image,
							productId: this.model.get('productId'),
							saleInformation: selectedFinish.discount
						})
					]
				}
			}
		});
	}
});
